import { isFunction } from 'lodash';
import raiseGeneralError from '../raiseGeneralError';
import { ValidationErrorType } from '../../types/validationErrorType';

export const handleSubmitError = (error, onValidationError) => {
    switch (error.key) {
        case ValidationErrorType.NAME_EXISTS:
        case ValidationErrorType.TOO_MANY_COLLECTIONS:
        case ValidationErrorType.TOO_MANY_ITEMS:
            handleBadRequest(error.key, onValidationError);
            break;
        default:
            raiseGeneralError();
    }
};

const handleBadRequest = (errorKey, onValidationError) => {
    if (isFunction(onValidationError)) {
        onValidationError(errorKey);
    } else {
        raiseGeneralError(errorKey);
    }
};
